var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#DEEBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47468_27152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1106 28.0716C22.1422 28.1505 22.1973 28.2179 22.2683 28.2646C22.3393 28.3113 22.4229 28.3352 22.5079 28.333C22.5929 28.3308 22.6752 28.3027 22.7438 28.2524C22.8123 28.2021 22.8638 28.1321 22.8914 28.0516L28.3081 12.2183C28.3347 12.1445 28.3398 12.0646 28.3227 11.9879C28.3057 11.9113 28.2671 11.8411 28.2116 11.7856C28.1561 11.7301 28.0859 11.6915 28.0093 11.6745C27.9326 11.6574 27.8527 11.6625 27.7789 11.6891L11.9456 17.1058C11.8651 17.1334 11.7951 17.1849 11.7448 17.2534C11.6945 17.322 11.6664 17.4043 11.6642 17.4893C11.662 17.5743 11.6859 17.6579 11.7326 17.7289C11.7793 17.7999 11.8467 17.855 11.9256 17.8866L18.5339 20.5366C18.7428 20.6203 18.9326 20.7453 19.0919 20.9043C19.2511 21.0633 19.3766 21.2529 19.4606 21.4616L22.1106 28.0716Z",
    stroke: "#0747A6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2104 11.7891L19.0938 20.9049",
    stroke: "#0747A6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47468_27152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSend);
export default __webpack_public_path__ + "static/media/home-send.f7d05791e2b596efb92388a7ef018989.svg";
export { ForwardRef as ReactComponent };